export default __webpack_public_path__ + "static/media/cameraSmall.95c88861.png";